import { validateArguments } from '../../SignatureValidation';
export var PowerFn;
(function (PowerFn) {
    PowerFn.Name = `POWER`;
    PowerFn.Stage = "SCALAR";
    PowerFn.Signature = `POWER(<base>, <exponent>)`;
    function make(callName, args, type, role) {
        return {
            name: PowerFn.Name,
            stage: PowerFn.Stage,
            data: { type, role },
            value: (...argVals) => {
                const [base, exp] = argVals;
                if (base == null || exp == null) {
                    return null;
                }
                if (typeof base === 'number' && typeof exp === 'number') {
                    return Math.pow(base, exp);
                }
                throw new Error(`Invalid input for POWER, base and exponent must be numeric`);
            },
        };
    }
    PowerFn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: PowerFn.Name, signature: PowerFn.Signature, location: callNode.location },
            arguments: ["NUMERIC", "NUMERIC"],
        };
        return validateArguments(sig, args);
    }
    PowerFn.validate = validate;
})(PowerFn || (PowerFn = {}));
